import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';

@Injectable()
export class HandleDecimalCommand implements OnFieldChanged {
  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent) {
    const quantityCtrl = formGroup.get(SpecFieldNames.QUANTITY);
    let isValid: boolean;
    const stringValue = quantityCtrl.value.toString();

    stringValue.split('.')['1'] === undefined || stringValue.split('.')['1'] === '5'
      ? (isValid = true)
      : (isValid = false);

    if (!isValid) {
      quantityCtrl.setErrors({ DecimalNotEmptyValidator: true });
    }
  }
}
